import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Gem, Scissors, HeartPulse, ArrowRight } from "lucide-react";
import { IMAGES } from "../lib/site";
import { PageHero, SectionHeading } from "../components/Sections";

const services = [
  {
    icon: Sparkles,
    title: "Brazilian Butt Lift",
    tagline: "Sculpted curvature, refined.",
    body: "Our signature BBL combines high-definition liposuction of the waist, flanks and back with meticulous fat transfer to the gluteal region. The result: a softly proportioned, naturally lifted silhouette designed in private 3D imaging consultation. Performed in our accredited suite under board-certified anesthesia, with same-day transfer to the recovery center.",
  },
  {
    icon: Gem,
    title: "Breast Enhancement",
    tagline: "Couture femininity.",
    body: "From tear-drop cohesive silicone to ultra-soft saline, every implant is selected in concert with your frame, lifestyle and aesthetic memory. We offer primary augmentation, mastopexy (lift), revision surgery and fat-grafting refinements — each tailored for grace, balance and longevity.",
  },
  {
    icon: Scissors,
    title: "Body Sculpting Suite",
    tagline: "The full silhouette ritual.",
    body: "High-definition liposuction, mommy makeover sequencing, abdominoplasty and arm contouring — performed solo or in artful combination. Our approach is conservative, considered, and committed to natural movement and skin quality.",
  },
  {
    icon: HeartPulse,
    title: "Concierge Recovery",
    tagline: "Heal as you were meant to.",
    body: "A medical recovery center reimagined as a private sanctuary. 24/7 licensed nursing, lymphatic drainage massage, nutritionist-curated meals, and serene suites with silk linens. Recovery becomes ritual.",
  },
];

export default function ServicesPage() {
  return (
    <div data-testid="page-services">
      <PageHero
        kicker="Signature Procedures"
        title="The art of the"
        accent="sculpted body"
        subtitle="Every procedure is performed with surgical artistry and resort-level discretion — designed around your story, not a template."
        image={IMAGES.gallerySilhouette}
        testid="services-hero"
      />

      <section className="py-20 md:py-28 bg-mag">
        <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-12">
          {services.map((s, i) => (
            <div
              key={i}
              data-testid={`service-block-${i}`}
              className={`grid md:grid-cols-12 gap-10 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}
            >
              <div className="md:col-span-5 [direction:ltr]">
                <div className="mag-card p-10 h-full">
                  <s.icon size={32} className="text-gold mb-6" />
                  <p className="text-[11px] tracking-[0.4em] uppercase text-pink-luxe">{s.tagline}</p>
                  <h3 className="font-heading text-4xl text-white mt-3">{s.title}</h3>
                </div>
              </div>
              <div className="md:col-span-7 [direction:ltr]">
                <p className="font-heading text-white/80 text-lg leading-relaxed">
                  {s.body}
                </p>
                <Link
                  to="/consultations"
                  className="btn-outline-gold mt-8"
                  data-testid={`service-block-cta-${i}`}
                >
                  Discuss this procedure <ArrowRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 bg-mag-2 border-t border-[rgba(212,175,55,0.18)]">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <SectionHeading
            kicker="Begin Your Journey"
            title="A consultation is the"
            accent="first stitch"
            align="center"
            testid="services-cta-heading"
          />
          <p className="text-white/65 font-heading text-lg mt-6 max-w-2xl mx-auto">
            We require an in-depth consultation before any procedure is
            confirmed. Reserve yours below.
          </p>
          <Link to="/consultations" className="btn-gold mt-8" data-testid="services-cta">
            Reserve Consultation
          </Link>
        </div>
      </section>
    </div>
  );
}
